import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { useLinkBasename } from './ScreensContext';

export const useLinkNavigate = (link) => {
  const navigate = useNavigate();
  const navRef = useRef(null);

  const basename = useLinkBasename(link);
  navRef.current = navigate;
  return (params, options) => {
    const to = link.stringify(params, { basename });
    return navRef.current(to, options);
  };
};
